const angular = require('angular');
const app = angular.module('learn-directives');
var userMentionsListHtml = require('../../templates/directives/user-mentions-list.html');

/**
 * Defines the share content component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Users injected to gain access to the Users resource
 * @argument {Resource} Shares injected to gain access to Shares resource
 * @argument {Resource} Analyze injected to gain access to Analyze resource
 */
app.directive('shareContent', ['Application', 'Authorization', 'Users', 'Shares', 'Analyze', '$translate', '$templateCache', function (Application, Authorization, Users, Shares, Analyze, $translate, $templateCache) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        contentType: "=",
        contentId: "=",
        open: "="
      },
      template: require('../../templates/directives/share-content.html'),
      controller: ['$scope', function ($scope) {
          // Added because the mentio plugin only allows for templateUrls, not templates, to satisfy our html-loader.
          $templateCache.put('templates/directives/user-mentions-list.html', userMentionsListHtml);

          var self = this;
          self.user = Authorization.getAuthToken().user;
          self.users = [];
          self.shares = '';
          $scope.typedTerm = '';
          self.loadingUsers = false;
          self.open = false;
          self.initials = '';
          var names = self.user.full_name.split(' ');
          self.initials += names[0][0];
          if (names.length > 1) {
            self.initials += names[names.length - 1][0];
          }
          self.initials = self.initials.toUpperCase();

          self.per_page = 6;
          self.page = 1;
          self.share = function () {
            var containerElement = angular.element("<div>" + self.shares + "</div>");
            var comment = containerElement.text().trim();
            var userTags = containerElement.children();
            var recipients = [];
            var authtoken = Authorization.getAuthToken();
            var user = authtoken.user;
            var typeChange = $scope.contentType === 'video' ? 'media' : $scope.contentType === 'file' ? 'media' : $scope.contentType;
            var share = {
              user: user._id,
              content_type: typeChange,
              comment: comment
            };
            share[typeChange] = $scope.contentId;
            angular.forEach(userTags, function (userTag) {
              recipients.push(userTag.id);
            });
            Shares.create({}, {share: share, recipients: recipients}, function (data) {
              var displayName = $scope.contentType === 'imported_content' ? 'course' : ($scope.contentType.charAt(0).toUpperCase() + $scope.contentType.substr(1));
              $translate('sharedContent.wasShared', { name: displayName }).then(function(translationData){
                Application.messaging.addMessage({type: 'success', text: translationData, duration: 5});
              });
              self.shares = '';
              recipients.forEach(function (recipient) {
                Analyze.record({resource: 'shares'}, {content: $scope.contentId, content_type: $scope.contentType, recipient: recipient});
              });
              Application.analyticsProvider.trackEvent($scope.contentType + '_shared');
              $scope.open = false;
            }, function (error) {
              var displayName = $scope.contentType === 'imported_content' ? 'course' : ($scope.contentType.charAt(0).toUpperCase() + $scope.contentType.substr(1));
              $translate('sharedContent.notShared', { name: displayName }).then(function(translationData){
                Application.messaging.addMessage({type: 'error', text: translationData, duration: 5});
              });
            });
          };
          self.reset = function() {
            self.shares = '';
            $scope.open = false;
          };
          $scope.mentionUser = function (user) {
            var htmlUserTag = '<div id="' + user._id + '" onclick="this.parentNode.removeChild(this);" contenteditable="false" class="ui image label">';
            if (user.image) {
              htmlUserTag += '<img class="ui avatar image" src="' + user.image.replace('http:', 'https:').replace('http%', 'https%') + '">'
            }
            htmlUserTag += user.full_name + '</div>';
            return htmlUserTag;
          };
          $scope.searchUsers = function (term) {
            if (term.length < 3) {
              return;
            }
            self.loadingUsers = true;
            Users.find({subresource: '', page: self.page, per_page: self.per_page, fields: 'first_name,last_name,email,full_name,role,image,office_location,last_login', role: '$ne,external', full_name: '$regex,2,' + term + ',i'}, function (users) {
              self.users = users;
              self.loadingUsers = false;
            }, function (error) {
              console.log('Error getting users.');
              self.loadingUsers = false;
            });
          };
          $scope.correctAvatar = function (user) {
            if (user.image) {
              return user.image.replace('http:', 'https:').replace('http%', 'https%');
            }
            return 'img/avatar-default.png';
          };
        }],
      controllerAs: 'share'
    };
  }]);
